import parent from '@/store/interfaces/historicalGeneric'
const mystore = parent({ tipoEvento: 'regla', namespaced: true })

export default mystore
